export default "__VITE_PUBLIC_ASSET__2a77506b__"